'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';

import { customRichTextTags } from '@/utils/i18n';

import { Reveal, SectionContainer } from '../_components';
import { DesktopSteps } from './desktop-steps';
import { MobileSteps } from './mobile-steps';

// 검사 순서(Process) 섹션. 스텝 선택 상태만 여기서 들고, 데스크탑/모바일 레이아웃에 전달한다.
export default function Process() {
  const t = useTranslations('Products.process');
  const [active, setActive] = useState(0);

  return (
    <Reveal>
      <SectionContainer className="px-5 md:px-0">
        <div className="flex flex-col items-center gap-8 md:gap-10">
          <div>
            <h2
              id="process-heading"
              className="text-center text-2xl font-semibold leading-8 tracking-[-0.464px] text-[#2B2E33] md:text-[48px] md:leading-[56px] md:tracking-[-1.072px]"
            >
              {t.rich('title', customRichTextTags)}
            </h2>
          </div>

          {/* 데스크탑: 좌측 스텝 리스트 + 우측 이미지·CTA (스텝 선택형) */}
          <div className="hidden w-full md:block">
            <DesktopSteps active={active} setActive={setActive} />
          </div>

          {/* 모바일: 아코디언 (활성 스텝만 CTA·이미지 노출) */}
          <div className="flex w-full flex-col gap-4 md:hidden">
            <MobileSteps active={active} setActive={setActive} />
          </div>
        </div>
      </SectionContainer>
    </Reveal>
  );
}
